import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
// import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import FooterTwo from "../component/footer/FooterTwo";


class PoliceReembolso extends Component{
    constructor () {
        super()
        this.state = {
          isOpen: false,
          username: window.location.pathname.split('/')[1],
        }
        this.openModal = this.openModal.bind(this);

    }

    openModal () {
        this.setState({isOpen: true})
    }

    render(){

        return(
            <React.Fragment>

                {/* Start Pagehelmet  */}
                <PageHelmet pageTitle='Políticas de Reembolso' />
                {/* End Pagehelmet  */}

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.webp" />

                {/* Start Breadcrump Area */}
                <div className="rn-page-title-area pt--120 pb--190 bg_image bg_image--5"  data-black-overlay="5">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    <h3 style={{color: 'white'}} className="title">
                

                {window.location.pathname.includes("refund-policies") ?
                "Refund Policies":
                "Políticas de Reembolso"    
                }
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Breadcrump Area */}

                {/* Start Page Wrapper */}
                <div className="rn-service-details ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="service-details-inner">
                                    <div className="inner">
                                        {/* Start Single Area */}

                                        <div className="row sercice-details-content pb--80 align-items-center">
                                           
                                            <div className="col-12">
                                                <div className="details mt_md--30 mt_sm--30">

                                                {window.location.pathname.includes("refund-policies") ?

                                                <>
                                                <body class="c11"><h2 class="c8" id="h.laof9t6et3v3"><span class="c9">Refund Policy</span></h2><p class="c6"><span class="c0">Thank you for purchasing our services!</span></p><p class="c6"><span class="c0">
At DojoFullStack, we want to make sure that all of our members are satisfied with their learning experience.
If at any point you feel that this program is not right for you, we would like to hear your feedback and help you in any way possible.

If you have attended the live sessions and decide that this program is not what you need within the first 30 days from the start date, we offer a full refund.
This is executed after 30 business days of requesting it.
</span></p><p class="c6"><span class="c1">Eligibility for Refunds and Exchanges</span></p><ul class="c4 lst-kix_gf8tfl1o4ruu-0 start"><li class="c5 li-bullet-0"><span class="c0">To complete your return, we require a receipt or proof of purchase for payment.</span></li>
<li class="c5 li-bullet-0"><span class="c0">To complete your return, we require an attached document with the reasons or causes for the return explained.</span></li>
<li class="c5 li-bullet-0"><span class="c0">
We strive to process your refund request in a timely manner. <br/>
Our team will carefully evaluate the case within approximately 3-5 business days and make a decision based on the reasons specified. <br/> We are committed to finding a fair and satisfactory solution for all of our members.
</span></li>

</ul>

<p class="c7"><span class="c0"></span></p><p class="c6 c10"><span class="c0"></span></p><p class="c6"><span class="c1">Late or missing refunds</span></p><ul class="c4 lst-kix_h5bn97qliijk-0 start"><li class="c5 li-bullet-0"><span class="c0">If you haven't received a refund yet, first check your bank account again. Then, contact your credit card company. It may take some time before your refund is officially posted (on average 30 days).</span></li><li class="c5 li-bullet-0"><span class="c3">If you’ve done all of this and you still have not received your refund yet, please contact us at hello@dojofullstack.com</span></li></ul>

</body>
                                                </>:

                                                <>
                                                   <body class="c11">
                                                   <section id="politica-reembolso">

<h3>Alcance del reembolso</h3>
<p>
  El reembolso total del <strong>100 %</strong> aplica únicamente al <strong>precio oficial o precio regular</strong> del Bootcamp Full Stack, y <strong>no aplica en caso de que se haya accedido a promociones o descuentos por temporada</strong>.
</p>


<h3>Plazo y condiciones</h3>
<ul>
  <li>La solicitud debe realizarse dentro de los <strong>30 días naturales</strong> contados a partir de la fecha de inicio del programa.</li>
  <li>El alumno debe haber asistido a las sesiones en vivo y notificar su decisión de no continuar antes de cumplirse los 30 días.</li>
</ul>

 <div class="policy-section">
        <h3>Limitaciones por uso de contenido y recursos</h3>
        
        <div class="highlight">
            <strong>El derecho al reembolso del 100% quedará automáticamente anulado si el alumno ha consumido más del 30% de los recursos o contenido del programa</strong>, incluyendo pero no limitado a:
        </div>

        <ul>
            <li>
                <span class="item-title">Materiales descargados:</span> Guías, PDFs, plantillas, código fuente, o cualquier recurso digital proporcionado
            </li>
            <li>
                <span class="item-title">Contenido de video:</span> Visualización de más del 30% de las clases grabadas o tutoriales disponibles
            </li>
            <li>
                <span class="item-title">Acceso a plataforma:</span> Uso activo de herramientas, simuladores, o entornos de desarrollo por más de 15 días desde el inicio
            </li>
            <li>
                <span class="item-title">Proyectos y ejercicios:</span> Envío o desarrollo de más del 30% de las actividades programadas
            </li>
            <li>
                <span class="item-title">Recursos complementarios:</span> Acceso a bibliotecas de código, APIs exclusivas, o material de apoyo técnico
            </li>
        </ul>

        <div class="no-refund">
            <strong>En caso de haber superado el 30% de consumo de contenido</strong>, el alumno <strong>NO tendrá derecho a reembolso alguno</strong> y deberá continuar con el programa hasta su finalización.
        </div>

        <div class="note">
            <strong>Nota importante:</strong> El porcentaje de consumo se calculará automáticamente a través de nuestro sistema de seguimiento de actividad en la plataforma.
        </div>
    </div>

<h3>Procedimiento</h3>
<ol>
  <li>
    Envía tu solicitud de reembolso junto con:
    <ul>
      <li>Comprobante de pago que acredite tu inscripción.</li>
      <li>Breve documento explicando las razones de la devolución.</li>
    </ul>
  </li>
  <li>Nuestro equipo evaluará tu caso en un plazo de <strong>3 a 5 días hábiles</strong>.</li>
  <li>Si corresponde, el reembolso se procesará dentro de los <strong>30 días hábiles</strong> siguientes a la aprobación.</li>
</ol>

<h3>Seguimiento de tu reembolso</h3>
<ul>
  <li>Verifica primero tu estado de cuenta; los bancos suelen demorar la publicación del abono.</li>
  <li>Si han transcurrido más de 30 días hábiles desde la aprobación y aún no lo recibes, contacta a tu entidad financiera.</li>
  <li>Para asistencia adicional, escríbenos a <a href="mailto:hola@dojofullstack.com">hola@dojofullstack.com</a>.</li>
</ul>

</section>



                                                            </body>
                                                </>
                                            }
                                                
                                                <br/>
                                                </div>
                                            </div>

                                        </div>
                                        {/* End Single Area */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Page Wrapper */}

                {/* Start Back To Top */}
          
                {/* End Back To Top */}


                <FooterTwo showWasi={false} />

            </React.Fragment>
        )
    }

    // async componentDidMount() {
    //    console.log(this.state.username)
    //   }
}
export default PoliceReembolso;
